/*
 * init-menus.js - js code to support menus
 *   show hide popup submenus
 *   modal login/signup from menus
 *   change menus for user login state
 */

jQuery(document).ready(($) => {
    // Open or close dropdown on first click
    $('#menu-primary-nav li.dropdown > a .caret').on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).closest('.dropdown').toggleClass('open');
    });

    // Open or close dropdown on first click
    $('#menu-primary-nav-spanish li.dropdown > a .caret').on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).closest('.dropdown').toggleClass('open');
    });

    // user menus support
    function refreshUserMenus() {
        if (CLWP_PC_GLOBAL.isLoggedIn) {
            $('.menu-logged-in').show();
            // $('.menu-logged-out').hide();
            $('.menu-item-login a').text('Log Out');
            $('.menu-item-login a').attr('href', CLWP_PC_GLOBAL.logoutURL);
        } else {
            // $('.menu-logged-out').show();
            $('.menu-logged-in').hide();
            $('.menu-item-login a').text('Sign In');
        }
    }

    refreshUserMenus();

    $(document).on('menu-refresh', refreshUserMenus);

    $('.menu-item-login').on('click', (e) => {
        const docData = $(document).data('events');
        if (docData && docData.pinesolDeviceSet && !CLWP_PC_GLOBAL.isLoggedIn) {
            e.preventDefault();
            $(document).trigger('show-login');
            return false;
        }
        return undefined;
    });

    $('.menu-item-signup').on('click', (e) => {
        const docData = $(document).data('events');
        if (docData && docData.pinesolDeviceSet && !CLWP_PC_GLOBAL.isLoggedIn) {
            e.preventDefault();
            $(document).trigger('show-signup');
            return false;
        }
        return undefined;
    });

    /*
    function is_touch_device() {
	  return !!('ontouchstart' in window);
	}

    // Disable link on touch devices so that clicking opens the dropdown menu and doesn't follow the link
    $('li.dropdown > a').on('click',function(e){
    	if((is_touch_device())) {
	    	e.preventDefault();
	    	return false;
    	}
    });
    */
});
